import PlataformApi from '@/services/plataformApi'

const Empresa = {
  components: {
    PlataformApi
  },
  
  state: () => ({
    configEmpresa: {}
  }),

  getters: {
    getConfigEmpresa: state => {
      return state.configEmpresa
    }
  },

  mutations: {
    setConfigEmpresa (state, configEmpresa) {
      state.configEmpresa = configEmpresa
    }
  },

  actions: {}
};

export default Empresa;